if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.carousel = null;
      this.blossom = null;
      this.slides = [];
      this.currentSlide = 0;
      this.slideCount = 0;
      this.prevButton = null;
      this.nextButton = null;
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      this.addedToCartDrawer = document.querySelector('added-to-cart-drawer');
    }

    connectedCallback() {
      this.initCarousel();
      this.initQuickAdd();
    }

    disconnectedCallback() {
      if (this.blossom) {
        this.blossom.destroy();
      }
    }

    initCarousel() {
      this.carousel = this.querySelector('.card-product__carousel');
      if (!this.carousel) return;

      this.slides = this.carousel.querySelectorAll('.card-product__slide');
      if (this.slides.length <= 1) return;

      this.slideCount = this.slides.length;
      this.prevButton = this.querySelector('.card-product__arrow--prev');
      this.nextButton = this.querySelector('.card-product__arrow--next');
      this.arrowsOnly = this.hasAttribute('data-arrows-only');

      // Initialize Blossom for drag support (skip if arrows-only mode)
      if (!this.arrowsOnly) {
        this.initBlossom();
      } else {
        // Disable scroll/touch on carousel when arrows-only
        this.carousel.style.overflow = 'hidden';
        this.carousel.style.touchAction = 'none';
      }

      // Initial state
      this.updateArrowStates();
      this.updateUIMode();

      this.prevButton?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.prev();
      });

      this.nextButton?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.next();
      });

      // Arrow key navigation when card has focus
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.prev();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.next();
        }
      });
    }

    initBlossom() {
      if (typeof BlossomCarousel !== 'undefined' && BlossomCarousel.Blossom) {
        this.blossom = BlossomCarousel.Blossom(this.carousel);
        this.blossom.init();
      } else {
        setTimeout(() => {
          if (typeof BlossomCarousel !== 'undefined' && BlossomCarousel.Blossom) {
            this.blossom = BlossomCarousel.Blossom(this.carousel);
            this.blossom.init();
          }
        }, 100);
      }
    }

    updateUIMode() {
      const currentSlideEl = this.slides[this.currentSlide];
      if (!currentSlideEl) return;

      const imageType = currentSlideEl.dataset.imageType;
      this.classList.toggle('card-product--light-ui', imageType === 'in-use' || imageType === 'photo');
    }

    updateArrowStates() {
      if (this.prevButton) {
        this.prevButton.disabled = this.currentSlide === 0;
      }
      if (this.nextButton) {
        this.nextButton.disabled = this.currentSlide >= this.slideCount - 1;
      }
    }

    prev() {
      if (!this.carousel || this.currentSlide === 0) return;
      this.currentSlide--;
      this.scrollToSlide(this.currentSlide);
    }

    next() {
      if (!this.carousel || this.currentSlide >= this.slideCount - 1) return;
      this.currentSlide++;
      this.scrollToSlide(this.currentSlide);
    }

    scrollToSlide(index) {
      const slideWidth = this.carousel.offsetWidth;
      this.carousel.scrollTo({
        left: slideWidth * index,
        behavior: 'smooth',
      });
      this.updateArrowStates();
      this.updateUIMode();
    }

    initQuickAdd() {
      const button = this.querySelector('.card-product__quick-add');
      if (!button) return;

      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.addToCart();
      });
    }

    async addToCart() {
      const button = this.querySelector('.card-product__quick-add');
      const variantId = this.dataset.variantId;

      if (!variantId || button.disabled) return;

      button.disabled = true;

      // Use added-to-cart drawer if available, otherwise fall back to cart drawer
      const drawerForRender = this.addedToCartDrawer || this.cart;

      try {
        const config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            sections: drawerForRender?.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname,
          }),
        };

        const response = await fetch(window.routes.cart_add_url, config);
        const data = await response.json();

        if (data.status) {
          // Error occurred
          if (typeof publish !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-card',
              productVariantId: variantId,
              errors: data.errors || data.description,
              message: data.message,
            });
          }
        } else {
          // Success
          if (typeof publish !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-card',
              productVariantId: variantId,
              cartData: data,
            });
          }

          if (drawerForRender) {
            drawerForRender.renderContents(data);
          }
        }
      } catch (error) {
        console.error('Add to cart error:', error);
      } finally {
        button.disabled = false;
      }
    }
  }

  customElements.define('product-card', ProductCard);
}
